import { Component, Inject, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Rental, RentalService, SaveForm } from '@tokeet-frontend/tv3-platform'
import * as lodash from 'lodash'
import * as R from 'ramda'

const dataMappings = {
  specialInstructions: 'specifics.special_inst',
  directionInstructions: 'instructions.directions',
  checkInInstructions: 'instructions.checkin',
  checkOutInstructions: 'instructions.checkout',
  houseRules: 'instructions.rules',
  paymentTerms: 'payment_terms',
  paymentInstructions: 'payment_instructions',
  checkTimes: ['checkin', 'checkout', 'timezone'],
  codes: ['specifics.sec_code', 'specifics.key_pickup', 'specifics.wifi_name', 'specifics.wifi_pass'],
}

@Component({
  selector: 'app-copy-rental-info-dialog',
  templateUrl: './copy-rental-info-dialog.component.html',
  styleUrls: ['./copy-rental-info-dialog.component.scss'],
  host: {
    class: 'modal-content',
  },
})
export class CopyRentalInfoDialogComponent implements OnInit {
  form = this.fb.group(
    {
      rentalId: [undefined, [Validators.required]],
      directionInstructions: [],
      checkInInstructions: [],
      checkOutInstructions: [],
      specialInstructions: [],
      houseRules: [],
      paymentTerms: [],
      paymentInstructions: [],
      checkTimes: [],
      codes: [],
    },
    {
      validators: [
        (form: FormGroup) => {
          const { rentalId, ...fields } = form.getRawValue()
          const data = lodash.filter(fields, (v) => v)
          return !data.length ? { fields: true } : null
        },
      ],
    }
  )

  constructor(
    public dialogRef: MatDialogRef<CopyRentalInfoDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { rentals: Rental[] }
  ) {}

  ngOnInit(): void {}

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  save(form: FormGroup) {
    const { rentalId, ...fields } = this.form.getRawValue()
    const rental = R.find((r: Rental) => r.id === rentalId, this.data.rentals)
    const data = lodash.reduce(
      fields,
      (acc, selected, field) => {
        if (selected) {
          const paths = typeof dataMappings[field] === 'string' ? [dataMappings[field]] : dataMappings[field]
          lodash.forEach(paths, (path) => {
            lodash.set(acc, path, path === 'timezone' ? RentalService.getTimeZone(rental) : lodash.get(rental, path))
          })
        }
        return acc
      },
      {}
    )
    this.dialogRef.close({ rental, data })
  }
}
